export default {
  path: '/financial-periods',
  component: () => import(/* webpackChunkName: "financial-periods" */ './FinancialPeriods'),
  props: route => ({ year: route.query.year }),
  meta: {
    requiresAuth: true
  }
}
